import controller from './oo-admin-relation.controller';
import template from './oo-admin-relation.html';
import './oo-admin-relation.scss';

export default {
	bindings: {
		node:    '=',
	},
	controller,
	template,
	controllerAs: '$ctrl',
	require: {
		parent: '^^ooAdmin',
	},
};
